import axios from 'axios';
import { SubPlantOperationsDto, AllSubPlantOperationsModel, SubPlantOperationsResponseModel, ProductionLogDetailsResponseModel } from '@gtpl/shared-models/production-management';
import { SubPlantCodesEnum, PlantsEnum, OperationTypeEnum, JobStatusEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import connection from './connection';

export class SubPlantOperationsService {
    URL = connection.DEPLOY_URL + '/prod-log';

    async getAllSubPlantOperations(req:UnitRequest): Promise<ProductionLogDetailsResponseModel> {
        return await axios.post(this.URL + '/getSubPlantHistoryDetails')
            .then(res => {
                return res.data
            })
    }
}